<template>
  <!-- <transition name="modal"> -->
  <div class="tmp-content-mask mx-auto">
    <!-- <div class="tmp-content-wrapper" > -->
    <div class='tmp-content'>
      <div class="header">
        <span class="header-title">{{componentTitle}}</span>
      </div>

      <div class="card" :class='{darkTheme: darkTheme}'>
        <div class="card-body scroll">

          <div class="content">

            <!-- TITLE -->
            <div class="form-group">
              <input v-model='title' type="text" class="custom-modern" :class="titleClass" id="tsk_title" placeholder="Title (required)"
                @click='refreshTitleError' @change="somethingChanged = true">
            </div>

            <!-- DESCRIPTION -->
            <div class="form-group">
              <!-- <label for="tsk_desc">Task description</label> -->
              <textarea v-model='description' class="form-control" id="tsk_desc" rows="3" placeholder="Describe the task (optional)"
                @change="somethingChanged = true"></textarea>
            </div>

            <!-- DEADLINE -->
            <div class="form-group mb-0" id='deadline' title='Deadline'>
              <i class="far fa-calendar-alt"></i>
              <date-picker v-model="deadline" type="datetime" lang="en" format="YYYY-MMM-DD HH:mm" :first-day-of-week="1"
                :minute-step="5" :not-before="new Date()" placeholder="Pick a deadline (optional)" confirm-text="Confirm"
                @change="dateInputChange" @input-error="dateInputErr" confirm></date-picker>
            </div>
            <small v-if="dateErr" class="text-danger ml-3rem">Deadline can't be in the past.</small>

            <!-- ADDING WORKERS -->
            <div class="form-group mt-3" id='adding-worker' title='Workers'>
              <i class="fas fa-user"></i>
              <multiselect v-model="selectedUSers" @select="somethingChanged = true" class="task-modal-input"
                :custom-label="fullName" track-by="id" placeholder="Assign to..." open-direction="bottom" :options="projectUsers"
                :multiple="true" :searchable="true" :internal-search="true" :clear-on-select="true" :close-on-select="true"
                :limit="5" :limit-text="limitText" :max-height="200" :show-no-results="false" :hide-selected="true"
                :allow-empty="true">
              </multiselect>
            </div>

            <!-- TAGS -->
            <div class="form-group" v-if="task">
              <span class='fas fa-tags' title='Tags'></span>

              <multiselect v-model="selectedTags" :options="projectTags" id="tags-component" class='task-modal-input'
                :multiple="true" :close-on-select="true" :clear-on-select="true" :hide-selected="true" :preserve-search="true"
                placeholder="Select Tags (optional)" label="tag_text" track-by="tag_text" :preselect-first="true"
                :show-no-results="false" open-direction="top" :maxHeight="200" @select="somethingChanged = true" @tag="addTag"
                :taggable="isProjectAdmin === 1">
              </multiselect>

            </div>

            <!-- PRIORITY -->
            <div v-show='task' class="form-group">
              <span class='fas fa-exclamation-circle' title='Priority'></span>

              <b-form-select v-model="selectedPriority" :class='selectedPriorityClass' class='task-modal-input' @change="somethingChanged = true">
                <option value="0">No priority</option>
                <option value='1'>Low</option>
                <!-- <option value='2'>Medium</option> -->
                <option value='3'>High</option>
              </b-form-select>
            </div>

            <!-- SUBMIT -->
            <div class="button-wrapper float-right">
              <button @click='taskCancel' @keydown.enter.prevent type="submit" class="btn btn-danger mr-1">
                <i class="fa fa-ban icon-sizes"></i>
                Cancel
              </button>
              <button @click='createTask' type="submit" class="btn btn-success" :disabled='blankTitle || waitNet'>
                <span v-show='edit'>
                  <span class='fa fa-edit'></span>
                  Edit</span>
                <span v-show='!edit'>
                  <span class='fa fa-plus-square'></span>
                  Create</span>
              </button>
            </div>
          </div>
        </div>

      </div>

    </div>
    <!-- </div> -->
  </div>
  <!-- </transition> -->
</template>

<script>
import DatePicker from "vue2-datepicker";

import { VueAutosuggest } from "vue-autosuggest";
import Multiselect from "vue-multiselect";
import { store } from "@/store/index";
import { api } from "@/api/index";
import { mapState, mapGetters } from "vuex";
import { routejs } from "@/router/routemanage.js";
var interval;

export default {
  components: {
    DatePicker,
    VueAutosuggest,
    Multiselect
  },

  data() {
    return {
      dateErr: false,

      projectUsers: [],
      projectTags: [],
      // a: false,
      somethingChanged: false,
      title: "",
      description: "",
      deadline: null,
      config: {
        //wrap: true, // set wrap to true only when using 'input-group'
        defaultDate: null,
        enableTime: true,
        time_24hr: true,
        dateFormat: "Y-m-d H:i:S",
        altFormat: "M	j, Y H:i",
        altInput: true,
        minDate: "today"
        // altInputClass: "hasError"
      },
      teamSelect: 0,
      waitNet: false,
      inputWorker: null,
      inputWorkerHaveChange: 0,
      choosenWorker: null,
      inputProps: {
        class: "autosuggest__input",
        onInputChange: this.onInputChange,
        placeholder: "Enter user"
      },
      selectedTags: [],
      inputTagHaveChange: 0,
      tagSearchStr: null,
      task: true,
      edit: false,
      suggestedProjets: [],
      inputPropsProject: {
        class: "autosuggest__input",
        onInputChange: this.onInputChangeProject,
        placeholder: "Enter Project"
      },
      selectedPriorityClass: "unselected form-control",
      selectedPriority: 0,
      projectSuggestionHaveChange: 0,
      mouseOverDeadline: 0,
      mouseOverAddWorker: 0,
      titleClass: "form-control",
      componentTitle: "Create Task",
      selectedUSers: []
    };
  },

  computed: {
    ...mapState({
      tabIndex: "currentTabIndex",
      suggestedWorker: state => store.getters.getSuggestedUsers,
      suggestedTags: state => state.modulework.suggestedTags,
      suggestedProjects: state => state.modulework.suggestedProjects,
      proId: state => state.sidebarItemSelection[0],
      isProjectAdmin: state => state.isProjectAdmin,
      darkTheme: state => state.darkTheme //,
    }),

    timeBeforeNow() {
      if (this.timecritical < 0) return true;

      if (this.deadline !== null || this.deadline !== undefined) {
        var now = this.parseTime(new Date());
        if (this.deadline < now) return false;
        return true;
      }
    },

    blankTitle() {
      return this.title.length === 0;
    },
    selectedProjectID() {
      var a = store.state.sidebarItemSelection[0];
      if (!a) return 0;
      else return a;
    }
  },

  mounted() {
    this.somethingChanged = false;
    this.projectTags = [];
    this.getProjectUsers();
    this.getProjectTags();
  },

  created: function() {
    interval = setInterval(() => {
      // Ovo bi trebalo stalno da poziva kompany ID
      // Pozivanje sugestija za tagove
      if (
        this.inputTagHaveChange == 1 &&
        this.tagSearchStr != null &&
        this.tagSearchStr.length > 0
      ) {
        store.dispatch("suggestTags", {
          tagFor: "task",
          searchStr: this.tagSearchStr,
          pro_id: this.proId
        });
        this.inputTagHaveChange = 0;
      }
    }, 500);

    this.somethingChanged = false;
  },

  destroy: function() {
    clearInterval(interval);
  },

  watch: {
    selectedTags: function() {
      store.dispatch("cleanSuggestedTags");
    },
    selectedPriority: function() {
      if (this.selectedPriorityClass != "form-control")
        this.selectedPriorityClass = "form-control";
    }
  },

  methods: {
    dateInputChange() {
      this.somethingChanged = true;
      this.dateErr = false;
    },

    dateInputErr() {
      this.dateErr = true;
      this.deadline = undefined;
    },

    getProjectUsers() {
      if (this.proId !== undefined) {
        api.getProjectUsers(this.proId).then(res => {
          if (!res) return;
          this.projectUsers = res.data.data;
        });
      }
      this.somethingChanged = false;
    },

    getProjectTags() {
      api.getProjectTags(this.proId).then(res => {
        if (!res) return;
        this.projectTags = res.data.data;
      });
      this.somethingChanged = false;
    },

    fullName({ name, surname, email }) {
      return name + " " + surname + " (" + email + ")";
    },

    taskCancel() {
      if (this.somethingChanged === true) {
        const options = {
          title: "Confirm?",
          okLabel: "Stay on page",
          cancelLabel: "Leave",
          size: "sm"
        };
        this.$dialogs
          .confirm(
            "Are you sure you want to leave? You might have unsaved changes!",
            options
          )
          .then(res => {
            if (!res) return;
            if (res.ok === false) store.dispatch("itemActionReset");
          });
      } else store.dispatch("itemActionReset");
    },

    addTag(newTag) {
      const tag = {
        tag_text: newTag
      };
      this.selectedTags.push(tag);
    },

    multiselectOut() {
      // Dodavanje novog taga
      var tag = this.tagSearchStr;

      if (
        this.suggestedTags.length > 0 ||
        tag == undefined ||
        tag == null ||
        tag.length == 0
      )
        return;

      for (var i in this.selectedTags)
        if (this.selectedTags[i].text == tag) return;
      this.selectedTags.push({
        text: tag
      });
    },
    selectUser() {
      this.teamSelect = false;
      this.personClass = "fas fa-user fas-selected";
      this.teamClass = "fas fa-users";
      this.inputProps.placeholder = "Enter User";
      this.$refs.suggestionTag.searchInput = null;
      this.choosenWorker = null;
      store.dispatch("cleanSuggestions");
    },
    onInputChange: function(text, oldText) {
      this.inputWorker = text;
      this.inputWorkerHaveChange = 1;
      if (this.choosenWorker != null) {
        if (!this.choosenWorker.status) this.choosenWorker = null;
        else this.choosenWorker.status = undefined;
      }

      if (text != null && text.length == 0) {
        store.dispatch("cleanSuggestions");
      }
    },
    onSelected(item) {
      if (item == null || item == undefined) return;
      this.choosenWorker = item.item;
      this.inputWorker = null;
      store.dispatch("cleanSuggestions");
      store.dispatch("cleanSuggestedTeams");
    },
    clickHandler(item) {},
    renderSuggestion(suggestion) {
      var str = this.inputWorker;
      var i = suggestion.item;
      if (this.teamSelect == 0) {
        // Selektovan je korisnik
        // Oznacavanje selektovanih slova
        return (
          <div class="sugestija">
            {" "}
            {this.oznaciIme(i.name, str)} {this.oznaciIme(i.surname, str)}{" "}
            {this.oznaciIme(i.email, str)}{" "}
          </div>
        );
      } else {
        // Selektovana je kompanija
        // return <div class='sugestija'>{this.oznaciIme(i.name, str)}</div>;
        // var array = ['Pera', 'Mika', 'Laza'];
        // const items = array.map((item, index) => {
        //   return <li>{item}</li>
        // });
        // return <ul> {items} </ul>;
        var items = this.oznaciTim(i.name, str);
        return <div class="sugestija"> {items} </div>;
      }
    },
    renderProjectSuggestion(suggestion) {
      return this.oznaciIme(
        suggestion.item.name,
        this.$refs.projectref._data.searchInput
      );
    },
    oznaciIme(ime, str) {
      if (!ime || ime === null) return;
      var reg = new RegExp(str, "i");
      var m = ime.search(reg);
      if (m != -1) {
        // Ako uopste ima preklapanja
        var pre = ime.replace(new RegExp("(.*?)" + str + ".*", "i"), "$1");
        var oznaceno = ime.replace(new RegExp(".*?(" + str + ").*", "i"), "$1");
        var posle = ime.replace(new RegExp(".*?" + str + "(.*)", "i"), "$1");
        return (
          <span class="rec">
            {" "}
            <span class="neoznacen"> {pre} </span>{" "}
            <span class="oznacen"> {oznaceno} </span>{" "}
            <span class="neoznacen"> {posle} </span>{" "}
          </span>
        );
      }
      return (
        <span class="rec">
          {" "}
          <span class="neoznacen"> {ime} </span>{" "}
        </span>
      );
    },
    oznaciTim(ime, str) {
      var reg = new RegExp(str, "i");
      var m = ime.search(reg);
      if (m != -1) {
        // Ako uopste ima preklapanja
        var array = ime.split(/\s+/);
        var items = array.map((item, index) => {
          var a = item.trim();
          if (a.length > 0) return this.oznaciIme(a, str);
        });
        return items;
      }
      return (
        <span class="rec">
          {" "}
          <span class="neoznacen"> {ime} </span>{" "}
        </span>
      );
    },
    calendarIconClicked() {
      this.$refs.datepicker._data.fp.open();
    },
    getSuggestionValue(item) {
      var i = item.item;
      if (this.teamSelect == 0) {
        // Selektovan je korisnik
        return i.name + " " + i.surname + " " + i.email;
      } else {
        return this.getSuggestionTeam(item);
      }
    },
    getSuggestionTeam(item) {
      var i = item.item;
      return i.name;
    },
    suggestUsers() {
      store.dispatch("refreshSuggestions", {
        searchText: this.inputWorker,
        pro_id: this.proId
      });
    },
    searchTags(str) {
      this.inputTagHaveChange = 1;
      this.tagSearchStr = str;
    },
    limitText(count) {
      return `and ${count} other people`;
    },

    // CREATING TASK
    async createTask() {
      this.waitNet = true;
      this.refreshErrors();
      // Provera ulaznih vrednosti
      if (this.title == null || this.title.length == 0) {
        this.titleError();
        return;
      }

      var tagarray = this.selectedTags.map(e => e.tag_text);
      var userarray = this.selectedUSers.map(e => e.id);

      if (
        this.deadline !== "" ||
        this.deadline !== null ||
        this.deadline !== undefined
      ) {
        this.deadline = this.localToUTC(this.deadline);
      } else {
        this.deadline = undefined;
      }
      try {
        let res = await api.createTask(
          this.title,
          this.description,
          this.deadline,
          tagarray,
          userarray,
          this.selectedPriority,
          this.selectedProjectID
        );

        store.commit("itemActionReset");
        store.commit("resetTaskView");

        store.commit("incDirtyCounter");

        this.reportWritingToDB(res);
      } catch (e) {
        return routejs.checkSession(e.response);
      } finally {
        this.waitNet = false;
      }
    },

    reportWritingToDB(result) {
      var status = result.data.status;
      if (status === "OK") {
        store.commit("toastStatus", {
          ok: true,
          message: "Task '" + this.title + "' has been created."
        });
      } else {
        store.commit("toastStatus", {
          ok: false,
          message: result.data.message //"Error! Task wasn't created."
        });
      }
    },

    onInputChangeProject(text, oldText) {
      if (text == null || text.length == 0) {
        store.dispatch("cleanSuggestedProjects");
      }
      this.projectSuggestionHaveChange = 1;
    },

    selectMe() {
      api.getUserInfo().then(res => {
        if (!res) return;
        var user = res.data;
        this.choosenWorker = user;
        this.$refs.suggestionTag.searchInput =
          user.name + " " + user.surname + " " + user.email;
      });
    },
    titleError() {
      this.titleClass = "form-control error-input";
    },
    refreshTitleError() {
      this.titleClass = "form-control";
    },
    projectError() {
      this.inputPropsProject.class = "autosuggest__input error-input66682";
    },
    refreshProjectError() {
      this.inputPropsProject.class = "autosuggest__input";
    },
    workerError() {
      this.inputProps.class = "autosuggest__input error-input66682";
    },
    refreshWorkerError() {
      this.inputProps.class = "autosuggest__input";
    },
    refreshErrors() {
      this.refreshProjectError();
      this.refreshTitleError();
    },
    onProjectSelected() {
      store.dispatch("cleanSuggestedProjects");
    },
    searchUsers(str) {
      if (!str || str === null) return;
      if (str.length == 0) {
        store.dispatch("cleanSuggestions");
        return;
      }
      store.dispatch("refreshSuggestions", {
        searchText: str,
        pro_id: this.proId
      });
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>
<style media="screen">
.darkTheme.maincontent .multiselect__single {
  color: #999 !important;
}

.maincontent .multiselect__single {
  color: #666 !important;
}
</style>

<style scoped>
.error-input {
  border-bottom: 3px solid #ff0000;
}

.header {
  position: absolute;
  user-select: none;
  position: relative;
  width: 150px;
  bottom: 30px;
  text-align: center;
  color: var(--ac-color);
  font-size: 1rem;
  margin: 0 auto;
}

.header-title {
  border-bottom: 2px solid;
  padding: 0 10px 5px 10px;
  font-weight: bold;
}

#adding-worker {
  position: relative;
}

.add-myself {
  background: var(--ac-bg-light-color);
  border: 3px solid var(--ac-bg-light-color);
  color: black;
  border-radius: 5px;
  position: absolute;
  right: 3px;
  top: 6px;
  cursor: pointer;
}

.cleane-deadline-wrapper {
  position: absolute;
  right: 10px;
  top: 0px;
}

.sugestija {
}

.rec {
  padding: 2px;
}

.neoznacen {
}

.oznacen {
  color: var(--ac-color);
}

.unselected {
  color: #6c757d !important;
}

.selected {
  color: #eee !important;
}

.tmp-content {
  position: relative;
}

.tmp-content-mask {
  width: 85%;
  margin: 0 auto;
}

.task-add-section {
  padding-top: 50px;
}

.task-modal-input {
  width: 520px;
  margin-left: auto;
  /* right: 0; */
}

/* .header {
  position: relative;
  height: 100px;
  padding: 20px 0 0;
  border-radius: 5px;
  color: black;
} */

.exit-text {
  position: absolute;
  top: 50px;
  right: 30px;
  font-size: 20px;
}

.exit-position {
  color: black !important;
  position: absolute;
  right: 20px;
  font-size: 30px;
}

.display-4 {
  position: absolute;
  width: 100%;
  text-align: center;
}

.form-control {
  display: inline;
  position: relative;
}

#tsk_deadline {
  width: 97%;
  cursor: pointer;
}

#tsk_desc {
  height: 240px;
}

.content .fas,
.content .far {
  color: var(--ac-color);
  font-size: 20px;
  margin: 3px;
  padding: 3px;
  cursor: pointer;
  width: 40px;
}

.icon-sizes {
  /* font-size: 10px; */
  font-weight: 900;
  margin: 0;
  padding: 0;
}

div.form-group {
  display: flex;
  align-items: center;
}

/* #auto-suggestion,
.calender-wrapper {
  padding-left: 22px;
  width: 100%;
}

#auto-suggestion .form-control {
  text-indent: 30px;
} */

.tags-wrapper {
  font-size: 18px;
}

.tag {
  background-color: var(--ac-bg-light-color);
  border: 1px solid var(--ac-bg-light-color);
  border-radius: 5px;
}

.tag-text {
}

.fa-times {
  font-size: 16px;
}

.button-wrapper {
  justify-content: right;
}

.modal-btn {
  margin-left: auto;
  width: 110px;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.multiselect__input {
  color: black;
}

.fas {
  width: 43px;
  margin: 0;
}

.task-modal-input {
  width: 100%;
}

.content select,
.content .tmp-content .deadline,
.content .multiselect {
  width: 100%;
}

.scroll {
  overflow: auto;
  min-height: 80vh;
  max-height: 85vh;
}

.ml-3rem {
  margin-left: 3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Content/Task/TaskAdd.vue